import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { FormControl } from "react-bootstrap";
import ReactDOM from "react-dom";
import _ from "lodash";
import $ from "jquery";

import CategoryActions from "../actions/CategoryActions";

import AccountingHelper from "../utils/AccountingHelper";

const Enums = window.Enums;

export default class CategorySelect extends React.Component
{
	constructor(props)
	{
		super(props);
		const stateFromProps = CategorySelect.getStateFromProps(props);
		stateFromProps.dropUp = false;
		this.state = stateFromProps;

		this.handleBlur = this.handleBlur.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleKeyDown = this.handleKeyDown.bind(this);
		this.handleSaveCategory = this.handleSaveCategory.bind(this);
		this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
	}

	static getStateFromProps(props)
	{
		// Sort the categories by usage count descending
		let options = props.options.sort((a,b) => b.usageCount - a.usageCount);
		const propsValue = props.value;
		const valueKey = props.valueKey || "id";
		const labelKey = props.labelKey || "name";
		if (valueKey !== "id" || labelKey !== "name")
		{
			options = options.map(option => {
				return {
					id: option[valueKey],
					name: option[labelKey]
				};
			});
		}
		const selectedOption = options.find(opt => opt[valueKey] == propsValue);
		const value = selectedOption ? selectedOption[labelKey] : "";
		const showCategoryAmounts = !!props.budgetItems;
		return {
			options,
			value,
			showCategoryAmounts,
			selectedIndex: 0,
			showCreate: false,
			expanded: false
		};
	}

	getShownOptions(value)
	{
		const lowerValue = value.toLowerCase();
		return this.state.options.filter(option => option.name.toLowerCase().includes(lowerValue)).slice(0, 10);
	}

	shouldDropUp()
	{
		let dropUp = false;
		if (this.textInput)
		{
			const $input = $(ReactDOM.findDOMNode(this.textInput));
			if (($input.offset().top - $(window).scrollTop())/$(window).height() > 0.5)
			{
				dropUp = true;
			}
		}
		return dropUp;
	}

	async handleSaveCategory(skipFocus, type)
	{
		if (this.textInput && !skipFocus)
		{
			_.defer(() => {
				ReactDOM.findDOMNode(this.textInput).focus();
			});
		}
		if (!type)
		{
			type = Enums.categoryType.unspecified;
		}
		const category = await CategoryActions.saveCategory({ name: this.state.value, type });
		this.handleOptionSelect(category, skipFocus);
	}

	handleOptionSelect(option, skipFocus)
	{
		this.props.onSelect(option);
		if (this.textInput && !skipFocus)
		{
			_.defer(() => {
				ReactDOM.findDOMNode(this.textInput).focus();
			});
		}
	}

	handleTextFieldChange(event)
	{
		const value = event.target.value || "";
		const shownOptions = this.getShownOptions(value);
		const showCreate = value && value.length > 0 && !shownOptions.some(option => option.name == value);

		this.setState({
			value,
			shownOptions,
			showCreate,
			selectedIndex: 0,
			expanded: true,
			dropUp: this.shouldDropUp()
		});
	}

	handleFocus(event)
	{
		if (!this.state.value)
		{
			this.setState({
				expanded: true,
				shownOptions: this.state.options.slice(0, 10),
				dropUp: this.shouldDropUp()
			});
		}
		this.props.onFocus(event);
	}

	handleBlur(event)
	{
		this.setState({expanded: false});
		this.props.onBlur(event);
	}

	async handleKeyDown(event)
	{
		const expanded = this.state.expanded;
		const showCreate = this.state.showCreate;
		let selectedIndex = this.state.selectedIndex;
		let maxIndex = this.state.shownOptions ? this.state.shownOptions.length : 0;
		if (!showCreate)
		{
			--maxIndex;
		}
		else
		{
			++maxIndex;
		}
		let isCreate = false;
		let type = Enums.categoryType.unspecified;
		if (showCreate)
		{
			if (selectedIndex === maxIndex - 1)
			{
				isCreate = true;
				type = Enums.categoryType.expense;
			}
			else if (selectedIndex === maxIndex)
			{
				isCreate = true;
				type = Enums.categoryType.income;
			}
		}
		let handled = false;
		switch (event.key)
		{
			case "ArrowDown":
				if (!expanded)
				{
					this.setState({
						expanded: true,
						shownOptions: this.getShownOptions(this.state.value || ""),
						dropUp: this.shouldDropUp()
					});
				}
				else
				{
					if (++selectedIndex > maxIndex)
					{
						selectedIndex = 0;
					}
					this.setState({selectedIndex});
				}
				handled = true;
				break;
			case "ArrowUp":
				handled = true;
				if (expanded)
				{
					if (--selectedIndex <= -1)
					{
						selectedIndex = maxIndex;
					}
					this.setState({selectedIndex});
				}
				break;
			case "Tab":
				if (expanded)
				{
					await this.handleKeyDownSelect(/*isTab*/ true, isCreate, type, selectedIndex);
				}
				break;
			case "Enter":
				if (expanded)
				{
					await this.handleKeyDownSelect(/*isTab*/ false, isCreate, type, selectedIndex);
					handled = true;
				}
				break;
			case "Escape":
				this.setState({expanded: false});
				break;
		}

		if (handled)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		if (_.isFunction(this.props.onKeyDown) && !handled)
		{
			this.props.onKeyDown(event);
		}
	}

	async handleKeyDownSelect(isTab, isCreate, categoryType, selectedIndex)
	{
		if (isCreate)
		{
			await this.handleSaveCategory(/*skipFocus*/ isTab, categoryType);
		}
		else
		{
			const toSelect = this.state.shownOptions[selectedIndex];
			this.props.onSelect(toSelect);
		}
	}

	componentWillReceiveProps(nextProps)
	{
		const stateFromProps = CategorySelect.getStateFromProps(nextProps);
		this.setState(stateFromProps);
	}

	render()
	{
		const currencyId = this.props.currencyId || null;
		const value = this.state.value;
		const lowerValue = value.toLowerCase();
		const options = this.state.shownOptions;
		const showCategoryAmounts = this.state.showCategoryAmounts;
		const showCreate = this.state.showCreate;
		const selectedIndex = this.state.selectedIndex;
		const maxIndex = options ? options.length : 0;

		if (showCategoryAmounts && options)
		{
			options.forEach(option =>
			{
				let budgetItem = this.props.budgetItems.find(budgetItem => budgetItem.categoryId === option.id && budgetItem.currencyId === currencyId);
				option.categoryAmount = budgetItem ? budgetItem.amount : 0;
			});
		}

		return (
			<div className="category-select">
				<div className={classNames(this.state.dropUp ? "dropup" : "dropdown" , {open: this.state.expanded})}>
					<FormControl
						type="text"
						className={classNames("form-control input-sm", this.props.className)}
						placeholder="Category"
						value={value}
						onChange={this.handleTextFieldChange}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onKeyDown={this.handleKeyDown}
						ref={(input) => this.textInput = input}
						autoFocus={this.props.autoFocus}
					/>
					<ul className="dropdown-menu">
						{options && options.map((option, index) => {
							const isSelected = index === selectedIndex;
							const showCategoryAmount = showCategoryAmounts && (option.categoryAmount || option.categoryAmount === 0);
							const labelAmount = showCategoryAmount
								? <span className="label label-info category-amount pull-right">{AccountingHelper.formatMoney(option.categoryAmount, currencyId)}</span>
								: null;
							let anchor;

							if (value)
							{
								const matchIndex = option.name.toLowerCase().indexOf(lowerValue);
								anchor = <a>{option.name.substr(0, matchIndex)}<u>{option.name.substr(matchIndex, value.length)}</u>{option.name.substr(matchIndex + value.length)}{labelAmount}</a>;
							}
							else
							{
								anchor = <a>{option.name}{labelAmount}</a>;
							}

							return (
								<li key={option.id} className={isSelected ? "active" : ""} style={{cursor: "pointer"}} onMouseDown={this.handleOptionSelect.bind(this, option, false)}>
									{anchor}
								</li>
							);
						})}
						{showCreate &&
							<li style={{cursor: "pointer"}} className={selectedIndex === maxIndex ? "active" : ""} onMouseDown={this.handleSaveCategory.bind(this, false, Enums.categoryType.expense)}>
								<a>Create new expense category: {value}</a>
							</li>
						}
						{showCreate &&
							<li style={{cursor: "pointer"}} className={selectedIndex === (maxIndex + 1) ? "active" : ""} onMouseDown={this.handleSaveCategory.bind(this, false, Enums.categoryType.income)}>
								<a>Create new income category: {value}</a>
							</li>
						}
					</ul>
				</div>
			</div>
		);
	}
}

CategorySelect.defaultProps = {
	onBlur: () => {},
	onFocus: () => {}
};

CategorySelect.propTypes = {
	onSelect: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyDown: PropTypes.func,
	autoFocus: PropTypes.bool,
	budgetItems: PropTypes.arrayOf(
		PropTypes.shape({
			amount: PropTypes.number,
			categoryId: PropTypes.number
		})
	),
	className: PropTypes.string,
	valueKey: PropTypes.string,
	labelKey: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			usageCount: PropTypes.number
		})
	),
	currencyId: PropTypes.number
};



// WEBPACK FOOTER //
// ./Components/components/CategorySelect.jsx